// extracted by mini-css-extract-plugin
export default {"header-container":"styles_header-container__xNO7M","main-container":"styles_main-container__l+BQu","subheader-container":"styles_subheader-container__4yP9D"};